var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"progress",staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.progress + '%' })}),_c('div',{ref:"bartext",staticClass:"progress-bar-text"},[_vm._v(_vm._s(_vm.progress + '%'))])])}
var staticRenderFns = []

export { render, staticRenderFns }